import { render, staticRenderFns } from "./OrganizationMenu.vue?vue&type=template&id=1931670c&scoped=true&"
import script from "./OrganizationMenu.vue?vue&type=script&lang=ts&"
export * from "./OrganizationMenu.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationMenu.vue?vue&type=style&index=0&id=1931670c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1931670c",
  null
  
)

export default component.exports